"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clone;
// TODO: Throw an error on empty `item` (Unexpected token u)
/**
 * Create a clone a value
 *
 * @param {*} item
 *
 * @example
 * const person1 = {name: 'John'};
 * const person2 = clone(person1); // Returns {name: 'John'}
 * // but
 * person1 !== person2 // Returns:  true
 */
function clone(item) {
  return global.JSON.parse(global.JSON.stringify(item));
}
//# sourceMappingURL=clone.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/clone.js
 ** module id = 25
 ** module chunks = 0 1
 **/